class CartUpsellVariantSelects extends VariantSelects {
  constructor() {
    super();
    
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    const cartUpsell = this.closest('cart-upsell');

    const currentImage = cartUpsell.querySelector('[data-cart-upsell-item-image]:not(.hidden)');
    const newImage = cartUpsell.querySelector(`[data-cart-upsell-item-image][data-media-id="${this.currentVariant.featured_media.id}"`);

    if (currentImage != newImage && newImage) {
      currentImage.classList.add('hidden');
      newImage.classList.remove('hidden');
    }
    
  }

  renderProductInfo() {
    const currentVariant = this.currentVariant;
    const sectionId = this.dataset.section;
    const cartUpsell = this.closest('cart-upsell');
    
    this.toggleAddButton(
      !currentVariant.available,
      window.variantStrings.soldOut
    );

    const currentPrice = cartUpsell.querySelector('[data-price]:not(.hidden)');
    const newPrice = cartUpsell.querySelector(`[data-price][data-variant-id="${currentVariant.id}"]`);

    if (currentPrice) currentPrice.classList.add('hidden');
    if (newPrice) newPrice.classList.remove('hidden');

  }
  
}

customElements.define('cart-upsell-variant-selects', CartUpsellVariantSelects);

class CartUpsell extends HTMLElement {
  constructor() {
    super();

    this.initSlider();
    
  }

  initSlider() {
    const cartUpsellItems = this.querySelectorAll('cart-upsell-item');
    if (cartUpsellItems.length <= 1) return;
    let settings = {};

    if (window.location.pathname == '/cart') {
      cartUpsellItems.forEach(item => {
        if (item.hasAttribute('data-cart-drawer-upsell-item')) {
          item.remove();
        }
      });

      Object.assign(settings, {
        loop: true,
        spaceBetween: 10,
        pagination: {
          el:'.swiper-pagination',
          clickable: true
        },
        autoplay: {
          delay: 10000
        }
      });
    } else {
      cartUpsellItems.forEach(item => {
        if (item.hasAttribute('data-cart-page-upsell-item')) {
          item.remove();
        }
      });

      this.mountDragScroller();
      return;
    }

    this.cartUpsellSlider = new Swiper(this, settings);
  }

  mountDragScroller() {
    const wrapper = this.querySelector('.cart-upsell__items-wrapper');
    console.log('[cart-upsell] mountDragScroller', { host: this, wrapper, customElDefined: !!customElements.get('drag-scroller') });
    if (!wrapper) {
      console.warn('[cart-upsell] no .cart-upsell__items-wrapper found');
      return;
    }

    this.classList.add('cart-upsell--drag');
    wrapper.setAttribute('data-scroller', '');

    const dragScroller = document.createElement('drag-scroller');
    const nextSibling = wrapper.nextSibling;
    const parent = wrapper.parentNode;
    dragScroller.appendChild(wrapper);
    parent.insertBefore(dragScroller, nextSibling);
    console.log('[cart-upsell] drag-scroller mounted', { dragScroller, wrapperParent: wrapper.parentElement });
  }

}

customElements.define('cart-upsell', CartUpsell);

class CartDrawerUpsell extends HTMLElement {
  constructor() {
    super();

    this.loadUpsell();
  }

  loadUpsell() {
    if (CartDrawerUpsell.cachedHTML) this.renderContent(CartDrawerUpsell.cachedHTML);
    fetch(`${window.location.origin}/cart`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        this.renderContent(html);
        CartDrawerUpsell.cachedHTML = html;
      });
  }

  renderContent(html) {
    const upsell = html.getElementsByTagName('cart-upsell')[0];
    if (!upsell || !upsell.getElementsByTagName('cart-upsell-item').length) {
      this.innerHTML = "";
    } else {
      upsell.querySelector('.swiper-pagination')?.remove();
      upsell.querySelectorAll('.swiper, .swiper-wrapper, .swiper-slide').forEach(el => {
        el.classList.remove('swiper', 'swiper-wrapper', 'swiper-slide');
      });
      this.innerHTML = upsell.outerHTML;
    }
  }

}

CartDrawerUpsell.cachedHTML;

customElements.define('cart-drawer-upsell', CartDrawerUpsell);